import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function StaffAvatar({ photoId, name, size = "h-9 w-9", testid }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let url = null;
    let cancelled = false;
    if (photoId) {
      api
        .get(`/files/${photoId}/download`, { responseType: "blob" })
        .then((r) => {
          if (!cancelled) {
            url = URL.createObjectURL(r.data);
            setSrc(url);
          }
        })
        .catch(() => {});
    } else {
      setSrc(null);
    }
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [photoId]);

  const initials = (name || "?")
    .split(" ")
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

  if (src) {
    return <img src={src} alt={name || "Staff photo"} className={`${size} rounded-full object-cover shrink-0`} data-testid={testid} />;
  }
  return (
    <div
      className={`${size} rounded-full bg-brand-light text-primary flex items-center justify-center text-xs font-bold shrink-0`}
      data-testid={testid}
      aria-label={name || "Staff"}
    >
      {initials}
    </div>
  );
}
